var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WujieVue',{attrs:{"width":"100%","height":"100%","name":"react17","url":_vm.react17Url,"sync":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }